module.exports = __webpack_public_path__ + "img/AddCommentOutlined.ce86fa05.svg";